import BackgroundImage from '@/operator/components/general/BackgroundImage';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import SignInDescription from '@/operator/components/modules/AuthPage/setup/signin/signInDescription';
import { PieChart } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import image from '@/operator/public/assets/images/background/translate-1.svg';
import { useSubdomain } from 'hooks/useSubdomain';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { ROUTES } from 'app/routes/constants';

const SignIn = (): JSX.Element => {
    const { t } = useTranslation();
    const { isSubdomainRoute } = useSubdomain();
    const navigate = useOrgNavigate();

    useEffect(() => {
        if (isSubdomainRoute) {
            navigate(ROUTES.HOME);
        }
    }, []);

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTip
                Icon={PieChart}
                headlineVariant="h1"
                headline={t('SignIn.Content.Header')}
                description={t('SignIn.Content.Description')}
                signInButton={<SignInDescription />}
            />

            <BackgroundImage src={image} />
        </StyledTwoScreensWrapper>
    );
};

export default SignIn;
